import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStoreService {
  constructor() {}

  setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key: string): any {
    const item = localStorage.getItem(key);
    if (!item || item === 'undefined' || item === 'null') {
      // setItem(chave, undefined) grava a STRING "undefined" (JSON.stringify(undefined) é undefined);
      // sem esse guarda o JSON.parse abaixo estoura e derruba quem só queria saber se há token.
      return null;
    }

    try {
      return JSON.parse(item);
    } catch {
      return null;
    }
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  public clear() {
    localStorage.clear();
  }
}